/**
 * Carries a GTM server container preview token from the URL to the marketing event call, so a
 * tester can watch events land in a preview session instead of firing tags for real.
 *
 * Held in `sessionStorage` because the purchase fires after the Stripe redirect, long after the
 * `?gtm_preview=` the tester started with has left the URL.
 */
const PREVIEW_PARAM = 'gtm_preview'
const STORAGE_KEY = 'zoe.gtmServerPreview'

/** Picks the token off the URL when present. Safe to call on every navigation. */
export const captureGtmServerPreviewToken = (params: URLSearchParams | null | undefined): void => {
  const token = params?.get(PREVIEW_PARAM)?.trim()
  if (!token || typeof window === 'undefined') return
  try {
    window.sessionStorage.setItem(STORAGE_KEY, token)
  } catch {
    // Storage throws in some privacy modes. A test affordance must never break a page.
  }
}

/** The captured token, or undefined when this is an ordinary visit. */
export const getGtmServerPreviewToken = (): string | undefined => {
  if (typeof window === 'undefined') return undefined
  try {
    return window.sessionStorage.getItem(STORAGE_KEY) ?? undefined
  } catch {
    return undefined
  }
}
